import _Object$keys from '/app/node_modules/babel-runtime/core-js/object/keys';
import _Array$from from '/app/node_modules/babel-runtime/core-js/array/from';
import _toConsumableArray from '/app/node_modules/babel-runtime/helpers/toConsumableArray';
import _Set from '/app/node_modules/babel-runtime/core-js/set';
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import PageBanner from '../PageBanner.vue';
import PageLimiter from '../PageLimiter.vue';
import Breadcrumbs from '../Breadcrumbs.vue';
import ProductTile from '../ProductTile.vue';
import CatalogMenu from '../CatalogMenu.vue';
import PageContent from '../PageContent.vue';

export default {
	name: 'PageCatalog',

	components: {
		PageBanner: PageBanner,
		PageLimiter: PageLimiter,
		Breadcrumbs: Breadcrumbs,
		ProductTile: ProductTile,
		CatalogMenu: CatalogMenu,
		PageContent: PageContent
	},

	props: {
		page: {
			type: Object,
			default: function _default() {
				return {};
			}
		},

		crumbs: {
			type: Array,
			default: function _default() {
				return [];
			}
		}
	},

	data: function data() {
		return {
			isChangeAnimate: false
		};
	},


	computed: {
		tagNav: function tagNav() {
			return this.page.tagNav;
		},
		bannerImage: function bannerImage() {
			var image = '',
			    tag = this.$route.query.tag;

			this.tagNav.forEach(function (el) {
				if (tag && tag === el.tag) image = el.banner;
			});

			return image || (this.page.banner || {}).image;
		},
		categories: function categories() {
			return this.page.tagNav || [];
		},
		brands: function brands() {
			return this.page.brandNav || [];
		},
		types: function types() {
			return this.page.typeNav || [];
		},
		items: function items() {
			return this.page.items || [];
		},
		filterItems: function filterItems() {
			var items = {};

			this.page.filter.forEach(function (f) {
				f.tags.forEach(function (tag) {
					items[tag.tag] = tag;
				});
			});

			return items;
		},
		grouped: function grouped() {
			var _this = this;

			return this.items
			// Группируем по категориям
			.reduce(function (res, i) {
				return (i.category || []).
				// Перебираем категории продукта
				forEach(function (cid) {
					return [
					// Обновляем/добавляем в результат категорию и запиливаем в неё этот продукт
					(res[cid] = res[cid] || { category: _this.categories.find(function (c) {
							return c.id === cid;
						}), items: [] }).items.push(i)];
				}) || res;
			}, {});
		},
		currentCategory: function currentCategory() {
			var _this2 = this;

			return this.categories.find(function (c) {
				return c.tag === _this2.$route.query.tag;
			}) || {};
		},
		currentBrand: function currentBrand() {
			var _this3 = this;

			return this.brands.find(function (c) {
				return c.tag === _this3.$route.query.brand;
			}) || {};
		},
		currentType: function currentType() {
			var _this4 = this;

			return this.types.find(function (c) {
				return c.tag === _this4.$route.query.type;
			}) || {};
		},
		currentFilter: function currentFilter() {
			return this.$route.query.filter ? this.$route.query.filter.split(',') : [];
		},
		itemsByCategory: function itemsByCategory() {
			// Фильтруем по текущей категории
			if (this.currentCategory.tag) {
				return this.grouped[this.currentCategory.id] ? this.grouped[this.currentCategory.id].items : [];
			}

			return this.items;
		},
		map: function map() {
			return this.itemsByCategory
			// Группируем по фильтрам
			.reduce(function (res, i) {
				return (i.filter || []).forEach(function (fid) {
					return [(res[fid] = res[fid] || []).push(i)];
				}) || res;
			}, {});
		},
		filters: function filters() {
			var _this5 = this;

			return this.page.filter
			// Отсеем опции фильтров которых нет
			.map(function (f) {
				return {
					title: f.title,
					tags: f.tags.slice().filter(function (tag) {
						return _this5.map[tag.id];
					})
				};
			})
			// Удалим пустые фильтры без опций
			.filter(function (f) {
				return f.tags.length;
			});
		},
		itemsFiltered: function itemsFiltered() {
			var _this6 = this;

			// TODO replace sets to array polyfills
			// Выбираем только те товары которые подходят под все фильтры (пересечение) this.map[filter.id] n this.map[filter.id]
			var items = new _Set(this.itemsByCategory.filter(function (el) {
				var flag = true;
				if (_this6.currentBrand && _this6.currentBrand.id) flag = el.brand.includes(_this6.currentBrand.id);
				if (_this6.currentType && _this6.currentType.id && flag) flag = el.type.includes(_this6.currentType.id);
				return flag;
			}));
			var tempItems = [];
			this.currentFilter.forEach(function (i) {
				var filter = _this6.filterItems[i];

				if (filter) {
					var filterMap = new _Set(_this6.map[filter.id]);
					tempItems = tempItems.concat(tempItems, [].concat(_toConsumableArray(items)).filter(function (i) {
						return filterMap.has(i);
					}));
				}
			});
			return _Array$from(tempItems.length ? new _Set(tempItems) : items);
		},
		isFiltered: function isFiltered() {
			return this.currentCategory.tag || this.currentFilter.length;
		},
		countLabel: function countLabel() {
			var count = this.isFiltered ? this.itemsFiltered.length : this.items.length;
			return count + ' ' + this.$lang('product', count, this.$store.state.settings.lang);
		},
		title: function title() {
			return this.isFiltered ? this.currentCategory.title : this.page.title;
		},
		currentSlugs: function currentSlugs() {
			var items = this.isFiltered ? this.itemsFiltered : this.page.items,
			    grouped = this.grouped,
			    slugs = [];

			if (!items.length && grouped) {

				_Object$keys(grouped).forEach(function (item) {

					//grouped[item].category = {};
					//grouped[item].category.isHidden = false;
					//if (grouped[item].category.isHidden) return
					items = items.concat(grouped[item].items);
				});
			}

			items.forEach(function (item) {
				var slug = item.link.split('/');
				slugs.push(slug[slug.length - 1]);
			});

			return slugs;
		}
	},

	watch: {
		currentFilter: function currentFilter(nv) {
			var _this7 = this;

			var length = nv.length;
			var filter = nv.filter(function (slug) {
				return _this7.filterItems[slug] && _this7.filterItems[slug].id && _this7.map[_this7.filterItems[slug].id];
			});

			if (filter.length < length) {
				this.$router.replace({ path: this.$route.path, query: { tag: this.currentCategory.tag, filter: filter.length ? filter.join(',') : undefined } });
			}
		},
		itemsFiltered: function itemsFiltered(val) {
			this.page.itemsFiltered = this.isFiltered ? val : null;
		},
		currentSlugs: function currentSlugs(val) {
			this.page.currentSlugs = val;
		},
		'$route.query': function $routeQuery() {
			var _this8 = this;

			this.isChangeAnimate = true;
			this.$scrollTo('#s-catalog', 200);

			setTimeout(function () {
				return _this8.isChangeAnimate = false;
			}, 400);
		}
	},

	created: function created() {
		this.page.currentSlugs = this.currentSlugs;
	}
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"babelrc":false,"cacheDirectory":true,"presets":[["/app/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./components/pages/PageCatalog.vue
// module id = ./node_modules/babel-loader/lib/index.js?{"babelrc":false,"cacheDirectory":true,"presets":[["/app/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./components/pages/PageCatalog.vue
// module chunks = 0